import { useListState } from "@react-stately/list";
import { useProvider } from "@react-spectrum/provider";
import { ProgressCircle } from "@react-spectrum/progress";
import { ListLayout } from "@react-stately/layout";
import { useSeparator } from "@react-aria/separator";
import { useLocale, useCollator, useMessageFormatter } from "@react-aria/i18n";
import { layoutInfoToStyle, useVirtualizerItem, Virtualizer, VirtualizerItem } from "@react-aria/virtualizer";
import { useOption, useListBoxSection, useListBox } from "@react-aria/listbox";
import { Text } from "@react-spectrum/text";
import { mergeProps } from "@react-aria/utils";
import { isFocusVisible, useHover } from "@react-aria/interactions";
import { Grid } from "@react-spectrum/layout";
import { FocusRing } from "@react-aria/focus";
import _spectrumIconsUiCheckmarkMedium from "@spectrum-icons/ui/CheckmarkMedium";
import _react, { useContext, useRef, Fragment, useMemo } from "react";
import { classNames, useStyleProps, SlotProvider, useDOMRef } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmInteropRequireDefault from "@babel/runtime/helpers/esm/interopRequireDefault";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import { Item, Section } from "@react-stately/collections";
export { Item, Section };
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

const $c2edd0492e78ecc0e4ab4ff84097401$export$ListBoxContext = _react.createContext(null);

// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/ar-AE.json
var $b4db831f7f2fc7552df30218524df8ba$exports = {};
$b4db831f7f2fc7552df30218524df8ba$exports = JSON.parse("{\"loading\":\"جار التحميل...\",\"loadingMore\":\"جار تحميل المزيد...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/bg-BG.json
var $bcf1604f0998f6eff192d9ab3c8a$exports = {};
$bcf1604f0998f6eff192d9ab3c8a$exports = JSON.parse("{\"loading\":\"Зареждане...\",\"loadingMore\":\"Зареждане на още...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/cs-CZ.json
var $d25208899ae4a979e55c412e86476769$exports = {};
$d25208899ae4a979e55c412e86476769$exports = JSON.parse("{\"loading\":\"Načítání...\",\"loadingMore\":\"Načítání dalších...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/da-DK.json
var $b683685bb45a3add92958b19a212592$exports = {};
$b683685bb45a3add92958b19a212592$exports = JSON.parse("{\"loading\":\"Indlæser ...\",\"loadingMore\":\"Indlæser flere ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/de-DE.json
var $fe118166d8d92a5b4990661bedad002d$exports = {};
$fe118166d8d92a5b4990661bedad002d$exports = JSON.parse("{\"loading\":\"Laden...\",\"loadingMore\":\"Mehr laden ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/el-GR.json
var $b9904a3893b28043282268ff7dda8b2$exports = {};
$b9904a3893b28043282268ff7dda8b2$exports = JSON.parse("{\"loading\":\"Φόρτωση...\",\"loadingMore\":\"Φόρτωση περισσότερων...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/en-US.json
var $f1dd8a067184a58cbc482b973eaf266$exports = {};
$f1dd8a067184a58cbc482b973eaf266$exports = JSON.parse("{\"loading\":\"Loading…\",\"loadingMore\":\"Loading more…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/es-ES.json
var $d893535c322bfd960ecec4b$exports = {};
$d893535c322bfd960ecec4b$exports = JSON.parse("{\"loading\":\"Cargando…\",\"loadingMore\":\"Cargando más…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/et-EE.json
var $f9555518c0ec9cb05244040ee31ce18a$exports = {};
$f9555518c0ec9cb05244040ee31ce18a$exports = JSON.parse("{\"loading\":\"Laadimine...\",\"loadingMore\":\"Laadi rohkem...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/fi-FI.json
var $c85a0bef278cddc163c89fda3b3bc143$exports = {};
$c85a0bef278cddc163c89fda3b3bc143$exports = JSON.parse("{\"loading\":\"Ladataan…\",\"loadingMore\":\"Ladataan lisää…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/fr-FR.json
var $f2a0223a5396b27584bd859e19223113$exports = {};
$f2a0223a5396b27584bd859e19223113$exports = JSON.parse("{\"loading\":\"Chargement...\",\"loadingMore\":\"Chargement supplémentaire...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/he-IL.json
var $b451906eebe06cf241a9cbe6b4e66cc1$exports = {};
$b451906eebe06cf241a9cbe6b4e66cc1$exports = JSON.parse("{\"loading\":\"טוען...\",\"loadingMore\":\"טוען עוד...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/hr-HR.json
var $d0f827a56aa9296e0a5acdcc1506$exports = {};
$d0f827a56aa9296e0a5acdcc1506$exports = JSON.parse("{\"loading\":\"Učitavam...\",\"loadingMore\":\"Učitavam još...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/hu-HU.json
var $e3e97122b4433196dda0fdc4870641$exports = {};
$e3e97122b4433196dda0fdc4870641$exports = JSON.parse("{\"loading\":\"Betöltés folyamatban…\",\"loadingMore\":\"Továbbiak betöltése folyamatban…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/it-IT.json
var $e5b018cf7ab337e8ecdd6ae67d09535a$exports = {};
$e5b018cf7ab337e8ecdd6ae67d09535a$exports = JSON.parse("{\"loading\":\"Caricamento...\",\"loadingMore\":\"Caricamento altri...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/ja-JP.json
var $b8c3f123632230edf19da947633bb$exports = {};
$b8c3f123632230edf19da947633bb$exports = JSON.parse("{\"loading\":\"読み込み中...\",\"loadingMore\":\"さらに読み込み中...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/ko-KR.json
var $dd43766fbea48e140d709cf42c5f474b$exports = {};
$dd43766fbea48e140d709cf42c5f474b$exports = JSON.parse("{\"loading\":\"로드 중\",\"loadingMore\":\"추가 로드 중\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/lt-LT.json
var $a1f54f25f2a8764dfcf2deb57cba213$exports = {};
$a1f54f25f2a8764dfcf2deb57cba213$exports = JSON.parse("{\"loading\":\"Įkeliama...\",\"loadingMore\":\"Įkeliama daugiau...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/lv-LV.json
var $c1fee82f3e4e2f70f6f030be1b79$exports = {};
$c1fee82f3e4e2f70f6f030be1b79$exports = JSON.parse("{\"loading\":\"Notiek ielāde...\",\"loadingMore\":\"Tiek ielādēts vēl...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/nb-NO.json
var $c4e8048723f29cfc59446d67a3c2df$exports = {};
$c4e8048723f29cfc59446d67a3c2df$exports = JSON.parse("{\"loading\":\"Laster inn ...\",\"loadingMore\":\"Laster inn flere ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/nl-NL.json
var $ae2e0522f914a10039a40ca2a9df$exports = {};
$ae2e0522f914a10039a40ca2a9df$exports = JSON.parse("{\"loading\":\"Laden...\",\"loadingMore\":\"Meer laden...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/pl-PL.json
var $f488a42de8cd360a4fdeaf5c16af$exports = {};
$f488a42de8cd360a4fdeaf5c16af$exports = JSON.parse("{\"loading\":\"Ładowanie...\",\"loadingMore\":\"Wczytywanie większej liczby...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/pt-BR.json
var $c935eb8095cab68288524c18262f8a9$exports = {};
$c935eb8095cab68288524c18262f8a9$exports = JSON.parse("{\"loading\":\"Carregando...\",\"loadingMore\":\"Carregando mais...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/ro-RO.json
var $e94847cd8fd68378c8ac6f8443cfc21$exports = {};
$e94847cd8fd68378c8ac6f8443cfc21$exports = JSON.parse("{\"loading\":\"Se încarcă...\",\"loadingMore\":\"Se încarcă mai multe...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/ru-RU.json
var $cd75e4831d4e7d175d4edf6dd5c4726$exports = {};
$cd75e4831d4e7d175d4edf6dd5c4726$exports = JSON.parse("{\"loading\":\"Загрузка...\",\"loadingMore\":\"Дополнительная загрузка...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/sk-SK.json
var $f4619fc8f59bf3ff5a4d7e29138a0908$exports = {};
$f4619fc8f59bf3ff5a4d7e29138a0908$exports = JSON.parse("{\"loading\":\"Načítava sa...\",\"loadingMore\":\"Načítava sa viac...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/sl-SI.json
var $d65ae4fe1101459eb84080d28e3d4$exports = {};
$d65ae4fe1101459eb84080d28e3d4$exports = JSON.parse("{\"loading\":\"Nalaganje...\",\"loadingMore\":\"Nalaganje več vsebine...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/sr-SP.json
var $f59eafb491bab435037cf7e3186a46$exports = {};
$f59eafb491bab435037cf7e3186a46$exports = JSON.parse("{\"loading\":\"Učitavam...\",\"loadingMore\":\"Učitavam još...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/sv-SE.json
var $b6631f328b50c422988b9072b0102$exports = {};
$b6631f328b50c422988b9072b0102$exports = JSON.parse("{\"loading\":\"Läser in...\",\"loadingMore\":\"Läser in mer...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/tr-TR.json
var $bdb1cf90ca054e5e50c6a5cd55322d76$exports = {};
$bdb1cf90ca054e5e50c6a5cd55322d76$exports = JSON.parse("{\"loading\":\"Yükleniyor...\",\"loadingMore\":\"Daha fazla yükleniyor...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/uk-UA.json
var $cac74d14475d82c020b1a5db6cf29a1$exports = {};
$cac74d14475d82c020b1a5db6cf29a1$exports = JSON.parse("{\"loading\":\"Завантаження…\",\"loadingMore\":\"Завантаження інших об’єктів...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/zh-CN.json
var $dd6cf2e626ff9dceb4356443d78ab$exports = {};
$dd6cf2e626ff9dceb4356443d78ab$exports = JSON.parse("{\"loading\":\"正在加载...¦\",\"loadingMore\":\"正在加载更多...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/listbox/intl/zh-TW.json
var $c6af3926f10523fc79dcf0ff8dfbdcfc$exports = {};
$c6af3926f10523fc79dcf0ff8dfbdcfc$exports = JSON.parse("{\"loading\":\"正在載入\",\"loadingMore\":\"正在載入更多...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/menu/vars.css
var $a0405c35323f8fc23474b1d62cf3a$exports = {};
$a0405c35323f8fc23474b1d62cf3a$exports = {
  "spectrum-Menu-popover": "_spectrum-Menu-popover_7c360",
  "spectrum-Menu": "_spectrum-Menu_7c360",
  "spectrum-Menu-sectionHeading": "_spectrum-Menu-sectionHeading_7c360",
  "spectrum-Menu-checkmark": "_spectrum-Menu-checkmark_7c360",
  "spectrum-Menu-item": "_spectrum-Menu-item_7c360",
  "is-selected": "_is-selected_7c360",
  "spectrum-Icon": "_spectrum-Icon_7c360",
  "spectrum-Menu-itemLabel": "_spectrum-Menu-itemLabel_7c360",
  "spectrum-Menu-itemIcon": "_spectrum-Menu-itemIcon_7c360",
  "spectrum-Menu-itemLabel--wrapping": "_spectrum-Menu-itemLabel--wrapping_7c360",
  "spectrum-Menu-divider": "_spectrum-Menu-divider_7c360",
  "spectrum-Menu-itemGrid": "_spectrum-Menu-itemGrid_7c360",
  "is-selectable": "_is-selectable_7c360",
  "spectrum-Menu-end": "_spectrum-Menu-end_7c360",
  "spectrum-Menu-icon": "_spectrum-Menu-icon_7c360",
  "spectrum-Menu-description": "_spectrum-Menu-description_7c360",
  "spectrum-Menu-keyboard": "_spectrum-Menu-keyboard_7c360",
  "focus-ring": "_focus-ring_7c360",
  "is-focused": "_is-focused_7c360",
  "is-hovered": "_is-hovered_7c360",
  "is-highlighted": "_is-highlighted_7c360",
  "is-open": "_is-open_7c360",
  "is-active": "_is-active_7c360",
  "is-disabled": "_is-disabled_7c360"
};
var $a0405c35323f8fc23474b1d62cf3a$$interop$default = $parcel$interopDefault($a0405c35323f8fc23474b1d62cf3a$exports);

/** @private */
function $fa6e2b9007aba67f0834db30ced41d8$export$ListBoxOption(props) {
  let {
    item,
    shouldSelectOnPressUp,
    shouldFocusOnHover,
    shouldUseVirtualFocus
  } = props;
  let {
    rendered,
    key
  } = item;
  let state = useContext($c2edd0492e78ecc0e4ab4ff84097401$export$ListBoxContext);
  let isSelected = state.selectionManager.isSelected(key);
  let isDisabled = state.disabledKeys.has(key);
  let isFocused = state.selectionManager.focusedKey === key;
  let ref = useRef();
  let {
    optionProps,
    labelProps,
    descriptionProps
  } = useOption({
    isSelected,
    isDisabled,
    'aria-label': item['aria-label'],
    key,
    shouldSelectOnPressUp,
    shouldFocusOnHover,
    isVirtualized: true,
    shouldUseVirtualFocus
  }, state, ref);
  let {
    hoverProps,
    isHovered
  } = useHover(_babelRuntimeHelpersEsmExtends({}, props, {
    isDisabled
  }));
  let contents = typeof rendered === 'string' ? /*#__PURE__*/_react.createElement(Text, null, rendered) : rendered;
  let isKeyboardModality = isFocusVisible();
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a0405c35323f8fc23474b1d62cf3a$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, mergeProps(optionProps, shouldFocusOnHover ? {} : hoverProps), {
    ref: ref,
    className: classNames($a0405c35323f8fc23474b1d62cf3a$$interop$default, 'spectrum-Menu-item', {
      // If using virtual focus, apply focused styles to the item when the user is interacting with keyboard modality
      'is-focused': shouldUseVirtualFocus && isFocused && isKeyboardModality,
      'is-disabled': isDisabled,
      'is-selected': isSelected,
      'is-selectable': state.selectionManager.selectionMode !== 'none',
      // When shouldFocusOnHover is false, apply hover styles both when hovered with the mouse.
      // Otherwise, apply hover styles when focused using non-keyboard modality.
      'is-hovered': isHovered && !shouldFocusOnHover || isFocused && !isKeyboardModality
    })
  }), /*#__PURE__*/_react.createElement(Grid, {
    UNSAFE_className: classNames($a0405c35323f8fc23474b1d62cf3a$$interop$default, 'spectrum-Menu-itemGrid')
  }, /*#__PURE__*/_react.createElement(SlotProvider, {
    slots: {
      text: _babelRuntimeHelpersEsmExtends({
        UNSAFE_className: $a0405c35323f8fc23474b1d62cf3a$$interop$default['spectrum-Menu-itemLabel']
      }, labelProps),
      icon: {
        size: 'S',
        UNSAFE_className: $a0405c35323f8fc23474b1d62cf3a$$interop$default['spectrum-Menu-icon']
      },
      description: _babelRuntimeHelpersEsmExtends({
        UNSAFE_className: $a0405c35323f8fc23474b1d62cf3a$$interop$default['spectrum-Menu-description']
      }, descriptionProps)
    }
  }, contents, isSelected && /*#__PURE__*/_react.createElement(_spectrumIconsUiCheckmarkMedium, {
    slot: "checkmark",
    UNSAFE_className: classNames($a0405c35323f8fc23474b1d62cf3a$$interop$default, 'spectrum-Menu-checkmark')
  })))));
}

/** @private */
function $a9178e65dcef03cae034af2a351953f9$export$ListBoxSection(props) {
  let {
    children,
    reusableView,
    header
  } = props;
  let item = reusableView.content;
  let {
    headingProps,
    groupProps
  } = useListBoxSection({
    heading: item.rendered,
    'aria-label': item['aria-label']
  });
  let {
    separatorProps
  } = useSeparator({
    elementType: 'li'
  });
  let headerRef = useRef();
  useVirtualizerItem({
    reusableView: header,
    ref: headerRef
  });
  let {
    direction
  } = useLocale();
  let state = useContext($c2edd0492e78ecc0e4ab4ff84097401$export$ListBoxContext);
  return /*#__PURE__*/_react.createElement(Fragment, null, /*#__PURE__*/_react.createElement("div", {
    role: "presentation",
    ref: headerRef,
    style: layoutInfoToStyle(header.layoutInfo, direction)
  }, item.key !== state.collection.getFirstKey() && /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, separatorProps, {
    className: classNames($a0405c35323f8fc23474b1d62cf3a$$interop$default, 'spectrum-Menu-divider')
  })), item.rendered && /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, headingProps, {
    className: classNames($a0405c35323f8fc23474b1d62cf3a$$interop$default, 'spectrum-Menu-sectionHeading')
  }), item.rendered)), /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, groupProps, {
    style: layoutInfoToStyle(reusableView.layoutInfo, direction),
    className: classNames($a0405c35323f8fc23474b1d62cf3a$$interop$default, 'spectrum-Menu')
  }), children));
}

// @ts-ignore
const $db61317aa22e4c1ceb7e68a142b3e28e$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($b4db831f7f2fc7552df30218524df8ba$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($bcf1604f0998f6eff192d9ab3c8a$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($d25208899ae4a979e55c412e86476769$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($b683685bb45a3add92958b19a212592$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($fe118166d8d92a5b4990661bedad002d$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($b9904a3893b28043282268ff7dda8b2$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($f1dd8a067184a58cbc482b973eaf266$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($d893535c322bfd960ecec4b$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($f9555518c0ec9cb05244040ee31ce18a$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($c85a0bef278cddc163c89fda3b3bc143$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($f2a0223a5396b27584bd859e19223113$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($b451906eebe06cf241a9cbe6b4e66cc1$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($d0f827a56aa9296e0a5acdcc1506$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($e3e97122b4433196dda0fdc4870641$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($e5b018cf7ab337e8ecdd6ae67d09535a$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($b8c3f123632230edf19da947633bb$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($dd43766fbea48e140d709cf42c5f474b$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($a1f54f25f2a8764dfcf2deb57cba213$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($c1fee82f3e4e2f70f6f030be1b79$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($c4e8048723f29cfc59446d67a3c2df$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($ae2e0522f914a10039a40ca2a9df$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($f488a42de8cd360a4fdeaf5c16af$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($c935eb8095cab68288524c18262f8a9$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($e94847cd8fd68378c8ac6f8443cfc21$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($cd75e4831d4e7d175d4edf6dd5c4726$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($f4619fc8f59bf3ff5a4d7e29138a0908$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($d65ae4fe1101459eb84080d28e3d4$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($f59eafb491bab435037cf7e3186a46$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($b6631f328b50c422988b9072b0102$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($bdb1cf90ca054e5e50c6a5cd55322d76$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($cac74d14475d82c020b1a5db6cf29a1$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($dd6cf2e626ff9dceb4356443d78ab$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($c6af3926f10523fc79dcf0ff8dfbdcfc$exports).default
};

/** @private */
export function useListBoxLayout(state) {
  let {
    scale
  } = useProvider();
  let collator = useCollator({
    usage: 'search',
    sensitivity: 'base'
  });
  let layout = useMemo(() => new ListLayout({
    estimatedRowHeight: scale === 'large' ? 48 : 32,
    estimatedHeadingHeight: scale === 'large' ? 33 : 26,
    padding: scale === 'large' ? 5 : 4,
    // TODO: get from DNA
    collator
  }), [collator, scale]);
  layout.collection = state.collection;
  layout.disabledKeys = state.disabledKeys;
  return layout;
}
/** @private */

function $db61317aa22e4c1ceb7e68a142b3e28e$var$ListBoxBase(props, ref) {
  let {
    layout,
    state,
    shouldSelectOnPressUp,
    focusOnPointerEnter,
    shouldUseVirtualFocus,
    domProps = {},
    transitionDuration = 0,
    onScroll
  } = props;
  let {
    listBoxProps
  } = useListBox(_babelRuntimeHelpersEsmExtends({}, props, domProps, {
    keyboardDelegate: layout,
    isVirtualized: true
  }), state, ref);
  let {
    styleProps
  } = useStyleProps(props);
  let formatMessage = useMessageFormatter($db61317aa22e4c1ceb7e68a142b3e28e$var$intlMessages); // Sync loading state into the layout.

  layout.isLoading = props.isLoading; // This overrides collection view's renderWrapper to support heirarchy of items in sections.
  // The header is extracted from the children so it can receive ARIA labeling properties.

  let renderWrapper = (parent, reusableView, children, renderChildren) => {
    if (reusableView.viewType === 'section') {
      return /*#__PURE__*/_react.createElement($a9178e65dcef03cae034af2a351953f9$export$ListBoxSection, {
        key: reusableView.key,
        reusableView: reusableView,
        header: children.find(c => c.viewType === 'header')
      }, renderChildren(children.filter(c => c.viewType === 'item')));
    }

    return /*#__PURE__*/_react.createElement(VirtualizerItem, {
      key: reusableView.key,
      reusableView: reusableView,
      parent: parent
    });
  };

  return /*#__PURE__*/_react.createElement($c2edd0492e78ecc0e4ab4ff84097401$export$ListBoxContext.Provider, {
    value: state
  }, /*#__PURE__*/_react.createElement(Virtualizer, _babelRuntimeHelpersEsmExtends({}, styleProps, mergeProps(listBoxProps, domProps), {
    ref: ref,
    focusedKey: state.selectionManager.focusedKey,
    sizeToFit: "height",
    scrollDirection: "vertical",
    className: classNames($a0405c35323f8fc23474b1d62cf3a$$interop$default, 'spectrum-Menu', styleProps.className),
    layout: layout,
    collection: state.collection,
    renderWrapper: renderWrapper,
    transitionDuration: transitionDuration,
    isLoading: props.isLoading,
    onLoadMore: props.onLoadMore,
    shouldUseVirtualFocus: shouldUseVirtualFocus,
    onScroll: onScroll
  }), (type, item) => {
    if (type === 'item') {
      return /*#__PURE__*/_react.createElement($fa6e2b9007aba67f0834db30ced41d8$export$ListBoxOption, {
        item: item,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        shouldFocusOnHover: focusOnPointerEnter,
        shouldUseVirtualFocus: shouldUseVirtualFocus
      });
    } else if (type === 'loader') {
      return (
        /*#__PURE__*/
        // aria-selected isn't needed here since this option is not selectable.
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        _react.createElement("div", {
          role: "option",
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
          }
        }, /*#__PURE__*/_react.createElement(ProgressCircle, {
          isIndeterminate: true,
          size: "S",
          "aria-label": state.collection.size > 0 ? formatMessage('loadingMore') : formatMessage('loading'),
          UNSAFE_className: classNames($a0405c35323f8fc23474b1d62cf3a$$interop$default, 'spectrum-Dropdown-progressCircle')
        }))
      );
    } else if (type === 'placeholder') {
      let emptyState = props.renderEmptyState ? props.renderEmptyState() : null;

      if (emptyState == null) {
        return null;
      }

      return /*#__PURE__*/_react.createElement("div", {
        // aria-selected isn't needed here since this option is not selectable.
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
      }, emptyState);
    }
  }));
} // forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref


export const ListBoxBase = _react.forwardRef($db61317aa22e4c1ceb7e68a142b3e28e$var$ListBoxBase);

function $aac92ce16efa62c1032703bf939f$var$ListBox(props, ref) {
  let state = useListState(props);
  let layout = useListBoxLayout(state);
  let domRef = useDOMRef(ref);
  return /*#__PURE__*/_react.createElement(ListBoxBase, _babelRuntimeHelpersEsmExtends({}, props, {
    ref: domRef,
    state: state,
    layout: layout
  }));
} // forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref

/**
 * A list of options that can allow selection of one or more.
 */


export const ListBox = _react.forwardRef($aac92ce16efa62c1032703bf939f$var$ListBox);
//# sourceMappingURL=module.js.map
